import React from 'react';
import Card, { CardFooter } from "UI/Card";
import Skeleton from "UI/Skeleton";

export default class PostSkeleton extends React.Component
{
    render()
    {
        const footer = <CardFooter className='flex justify-end space-x-2'>
            <Skeleton className='h-10 w-16 rounded' />
            <Skeleton className='h-10 w-24 rounded' />
            <Skeleton className='h-10 w-20 rounded' />
        </CardFooter>;

        return <Card footer={footer}>
            <div className='space-y-8'>
                <div className='flex space-x-4'>
                    <Skeleton className='flex-shrink-0 h-12 w-12 rounded-full' />
                    <div className='flex-grow space-y-2'>
                        <Skeleton className='h-6 w-1/2 rounded' />
                        <Skeleton className='h-4 w-1/3 rounded' />
                    </div>
                </div>
                <div className='space-y-2'>
                    <div className='flex space-x-2'>
                        <Skeleton className='h-2 w-1/12 rounded' />
                        <Skeleton className='h-2 w-1/4 rounded' />
                        <Skeleton className='h-2 w-1/6 rounded' />
                        <Skeleton className='h-2 w-1/4 rounded' />
                        <Skeleton className='h-2 w-1/4 rounded' />
                    </div>
                    <div className='flex space-x-2'>
                        <Skeleton className='h-2 w-1/4 rounded' />
                        <Skeleton className='h-2 w-1/4 rounded' />
                        <Skeleton className='h-2 w-1/12 rounded' />
                        <Skeleton className='h-2 w-1/6 rounded' />
                    </div>
                </div>
            </div>
        </Card>
    }
}
